import React, { useState } from "react";
import Resultado from "./components/Resultado";
import Historico from "./components/Historico";
import GraficoPizza from "./components/GraficoPizza";
import LinksIMC from "./components/LinksIMC";
import "./styles/global.css";

function App() {
  const [peso, setPeso] = useState("");
  const [altura, setAltura] = useState("");
  const [imc, setImc] = useState(null);
  const [mensagem, setMensagem] = useState("");
  const [erro, setErro] = useState("");
  const [camposInvalidos, setCamposInvalidos] = useState({ peso: false, altura: false });

  const [historico, setHistorico] = useState(() => {
    const dados = localStorage.getItem("historicoIMC");
    return dados ? JSON.parse(dados) : [];
  });

  const calcularIMC = () => {
    let invalido = false;
    const novosInvalidos = { peso: false, altura: false };

    if (!peso) {
      novosInvalidos.peso = true;
      invalido = true;
    }
    if (!altura) {
      novosInvalidos.altura = true;
      invalido = true;
    }

    setCamposInvalidos(novosInvalidos);

    if (invalido) {
      setErro("Por favor, preencha peso e altura antes de calcular.");
      setTimeout(() => setErro(""), 3000);
      return;
    }

    const valor = (peso / (altura * altura)).toFixed(2);

    const registro = {
      valor,
      data: new Date().toLocaleDateString(),
      hora: new Date().toLocaleTimeString(),
    };

    setImc(valor);

    setHistorico((prevHistorico) => {
      const novoHistorico = [...prevHistorico, registro];
      const limitado = novoHistorico.slice(-10);
      localStorage.setItem("historicoIMC", JSON.stringify(limitado));
      return limitado;
    });

    setErro("");
    setCamposInvalidos({ peso: false, altura: false });
    setMensagem("Cálculo realizado com sucesso!");
    setTimeout(() => setMensagem(""), 3000);
  };

  return (
    <div className="layout">
      <div className="centro">
        <h1>Calculadora de IMC</h1>
        <div className="inputs">
          <label htmlFor="peso">Peso (kg)</label>
          <input
            id="peso"
            type="number"
            placeholder="Digite seu peso"
            value={peso}
            onChange={(e) => setPeso(e.target.value)}
            className={camposInvalidos.peso ? "input-erro" : ""}
          />

          <label htmlFor="altura">Altura (m)</label>
          <input
            id="altura"
            type="number"
            placeholder="Digite sua altura"
            value={altura}
            onChange={(e) => setAltura(e.target.value)}
            className={camposInvalidos.altura ? "input-erro" : ""}
          />

          <button onClick={calcularIMC}>Calcular</button>
        </div>
        {imc && <Resultado imc={imc} />}
        <Historico
          historico={historico}
          onLimpar={() => {
            localStorage.removeItem("historicoIMC");
            setHistorico([]);
            setMensagem("Histórico apagado com sucesso!");
            setTimeout(() => setMensagem(""), 3000);
          }}
        />
        {mensagem && <p className="mensagem">{mensagem}</p>}
        {erro && <p className="erro">{erro}</p>}
      </div>

      <div className="esquerda">
        <GraficoPizza historico={historico} />
      </div>
      <div className="direita">
        <LinksIMC />
      </div>
    </div>
  );
}

export default App;